import { observer } from "mobx-react-lite";
import styles from "../Login.module.css";
import { authLocalData, authStore } from "../../../stores/AuthStore";
import { AnimationEvent, useEffect, useRef } from "react";

export const Puzzles = observer(() => {
    const parentPuzzlesCaptcha = useRef<HTMLDivElement>(null);

    const { isLoadingImage, isPhraseArray } = authStore;
    const { setValuePhrase, setNodePuzzle } = authLocalData;

    const handleAddSymbol = (e: React.MouseEvent) => {
        const puzzle = e.currentTarget;
        setValuePhrase(puzzle.textContent || "");
        puzzle.classList.add(styles.active);
    };

    useEffect(() => {
        if (parentPuzzlesCaptcha.current) {
            setNodePuzzle(parentPuzzlesCaptcha.current, styles.active);
        }

        return () => authStore.dispose();
    }, []);

    const trackingAnimationEnd = (e: AnimationEvent) => {
        console.log(e.animationName);

        if (e.animationName.includes("warning")) {
            authLocalData.clearError();
        }
    };

    return (
        <div
            ref={parentPuzzlesCaptcha}
            className={`${styles.fivePuzzleCaptcha} ${
                isLoadingImage && styles.loading
            } ${authLocalData.error ? styles.warning : ""}`}
            onAnimationEnd={trackingAnimationEnd}
        >
            <div onClick={handleAddSymbol} className={styles.isPuzzleCaptcha}>
                {isPhraseArray[0]}
            </div>
            <div onClick={handleAddSymbol} className={styles.isPuzzleCaptcha}>
                {isPhraseArray[1]}
            </div>
            <div onClick={handleAddSymbol} className={styles.isPuzzleCaptcha}>
                {isPhraseArray[2]}
            </div>
            <div onClick={handleAddSymbol} className={styles.isPuzzleCaptcha}>
                {isPhraseArray[3]}
            </div>
            <div onClick={handleAddSymbol} className={styles.isPuzzleCaptcha}>
                {isPhraseArray[4]}
            </div>
        </div>
    );
});
